import { ContextualActionsWrapper, entityGetByPath, entityReset, Node, referenceLoadingReset, Taxonomy } from '@uncinc/react-drupal-core';
import { Map } from 'immutable';
import { usePrevious } from '@uncinc/uncinc-react-kitchen-sink';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container } from '../../components';
import NotFound from '../NotFound';
import Maintenance from '../Maintenance';
import Page from '../Page';
import SocialsList from '../../components/SocialsList';

const Entity = () => {
  const dispatch = useDispatch();
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const childEntity = useSelector((state) => state.getIn([entityType, entityId], Map()));
  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const entityStatus = useSelector((state) => state.getIn(['entity', 'status']));
  const prevPath = usePrevious(path);


  const getErrorType = (entityStatus) => {
    if(entityStatus === 404) return "not-found"
    if(entityStatus === 503) return "maintenance"
    if(String(entityStatus).charAt(0) === '5') return "other"
  }

  const errorType = getErrorType(entityStatus);

  // When this component unmounts, we are most likely navigating to a non-entity
  // route. In order to prevent old entity data from being rendered on subsequent
  // entity routes, we want to reset the current entity in the state.
  React.useEffect(() => {
    return () => {
      dispatch(entityReset());
    };
  }, [dispatch]);

  React.useEffect(() => {
    if (!entityType || !entityId) {
      dispatch(entityGetByPath(path));
    }

    if (path !== prevPath) {
      dispatch(referenceLoadingReset());
      dispatch(entityGetByPath(path));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityType, entityId, path]);

  if (errorType === "not-found" || errorType === "other") {
    return (
      <Container small>
        <NotFound entityStatus={entityStatus} entityType={entityType} />
      </Container>
    );
  }

  if (errorType === "maintenance") {
    return (
      <>
      <Container small>
        <Maintenance entityStatus={entityStatus} entityType={entityType} />
      </Container>
        <SocialsList />
      </>
    );
  }

  return (
    <ContextualActionsWrapper>
      <Page title={childEntity.getIn(['title', 0, 'value'], '')}>
        {entityType === 'node' && (
          <Node root id={entityId} />
        )}
        {entityType === 'taxonomy_term' && (
          <Taxonomy root id={entityId} />
        )}
      </Page>
    </ContextualActionsWrapper>
  );
};

export default Entity;
